import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.8829 12H5.38973M5.38973 12L3.53848 18.9892C3.41748 19.4465 3.57555 19.9322 3.94246 20.2306C4.30937 20.5291 4.81709 20.5849 5.2401 20.3734L19.8383 13.0762C20.246 12.8724 20.5035 12.4558 20.5035 12C20.5035 11.5443 20.246 11.1276 19.8383 10.9239L5.2401 3.62668C4.81709 3.41512 4.30937 3.47097 3.94246 3.76943C3.57555 4.06788 3.41748 4.55359 3.53848 5.01082L5.38973 12Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
